import { For, Switch, Match, createContext, createEffect, createMemo, createSignal, useContext } from "solid-js";
import styles from './k12-hallpass-studentrestrictions.module.css'
import { requireViewContext } from "st-app";
import { Spinner as StSpinner } from "st-app";
import { k12HallpassStudentrestrictions as api, StudentHallPassRestrictionsData, StudentHallPassRestrictionGroupData, StudentHallPassRestrictionData } from 'sis-app/api';

class K12HallpassStudentrestrictionsContext {

}

class K12HallpassStudentrestrictionsProps {
    context?: K12HallpassStudentrestrictionsContext
    ssyGU: string = ""
}

const k12HallpassStudentrestrictionsContext = createContext(new K12HallpassStudentrestrictionsContext());


export const useK12HallpassStudentrestrictionsContext = () => useContext(k12HallpassStudentrestrictionsContext);



export default function K12HallpassStudentrestrictions(props: K12HallpassStudentrestrictionsProps) {
    const context = createMemo(() => props.context || new K12HallpassStudentrestrictionsContext());

    return <k12HallpassStudentrestrictionsContext.Provider value={context()}>
        <K12HallpassStudentrestrictionsInner {...props} />
    </k12HallpassStudentrestrictionsContext.Provider>
}
K12HallpassStudentrestrictions.defaultProps = new K12HallpassStudentrestrictionsProps();


function K12HallpassStudentrestrictionsInner(props: K12HallpassStudentrestrictionsProps) {
    const [restrictionData, setRestrictionData] = createSignal<StudentHallPassRestrictionsData | undefined>();

    createEffect(() => {
        setRestrictionData(undefined);
        if (props.ssyGU) {
            api.LoadData(props.ssyGU)
                .then(setRestrictionData);
        }
    });

    return <div class={styles.studentHallPassesData}>
        <Switch>
            <Match when={restrictionData()?.hasData === true}>
                <For each={restrictionData()?.groups ?? []}>{group =>
                    <Group group={group} />
                }</For>
            </Match>
            <Match when={restrictionData()?.hasData === false}>
                <div class={styles.noData}>
                    <span class={styles.noDataMsg}>No Restrictions</span>
                </div>
            </Match>
            <Match when={props.ssyGU}>
                <StSpinner />
            </Match>
        </Switch>
    </div>
}

function Group(props: { group: StudentHallPassRestrictionGroupData }) {
    const group = props?.group;

    return <div class={styles.group}>
        <div class={styles.groupLabel}>{group.restrictionGroupName}</div>
        <For each={group.studentRestrictions ?? []}>{stuRestriction =>
            <StudentRestriction stuRestriction={stuRestriction} />
        }</For>

    </div>
}

function StudentRestriction(props: { stuRestriction: StudentHallPassRestrictionData }) {
    const stuRestriction = props?.stuRestriction;

    return <div class={styles.stuRestriction}>
        <span><img class={styles.stuImage} src={stuRestriction.studentPhoto} alt={stuRestriction.studentName} width="30" height="30"></img></span>
        <span class={styles.stuName}>{stuRestriction.studentName}</span>
    </div>
}

